module.exports = __webpack_public_path__ + "img/0S6A9878.aa08477c.jpg";